/**
 * 竞价预告列表页
 */
export const APPLY_ANNOUNCEMENT_LIST_PAGE_PATH = '/announcement/apply/list'

/**
 * 竞价预告新增页
 */
export const APPLY_ANNOUNCEMENT_CREATE_PAGE_PATH = '/announcement/apply/create'

/**
 * 竞价预告编辑页
 */
export const APPLY_ANNOUNCEMENT_EDIT_PAGE_PATH = '/announcement/apply/edit'

/**
 * 竞价预告详情页
 */
export const APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH = '/announcement/apply/detail'

/**
 * 频道管理页
 */
export const APPLY_ANNOUNCEMENT_CHANNEL_PAGE_PATH =
  '/announcement/apply/channel'
